<!--体验卡消费列表-->
<template>
  <div  class="app-container">
    <!--查询条件区域-->
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="会员卡号:">
                <el-input v-model="queryParam.userPhone" placeholder="输入卡号" style="width: 200px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="会员姓名:">
                <el-input v-model="queryParam.childName" placeholder="输入会员姓名" style="width: 200px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="会员小名:">
                <el-input v-model="queryParam.childPetName" placeholder="输入小名" style="width: 200px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="服务泳师:">
                <el-select  v-model="queryParam.serviceTeacher" placeholder="请选择" @change="onChaneWork" style="width: 200px;">
                  <el-option
                    v-for="item in allWorker"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="卡类型:">
                <el-select  v-model="queryParam.storeLessonCardId" placeholder="请选择" @change="onChaneWork" style="width: 200px;">
                  <el-option
                    v-for="item in allStoreLessonCard"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="业务类型:">
                <el-select  v-model="queryParam.lessonTemplateId" placeholder="请选择" @change="onChangeDay" style="width: 200px;">
                  <el-option
                    v-for="item in redioType"
                    :key="item.lessonTemplateId"
                    :label="item.des"
                    :value="item.lessonTemplateId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="消费日期:">
                <el-date-picker
                  v-model="queryParam.consumeDay"
                  type="daterange"
                  range-separator=""
                  start-placeholder="开始"
                  value-format="yyyy-MM-dd"
                  end-placeholder="结束">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>

    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="danger" size="medium" class="operator-btn3" style="width: 120px;" icon="el-icon-refresh-left" @click="handleRevokeConsume()">撤销</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                style="width: 100%"
                :data="tableData"
                max-height="460"
                v-loading="listLoading" border
                highlight-current-row
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="userPhone" label="卡号" ></el-table-column>
        <el-table-column prop="cardName" label="卡类型" ></el-table-column>
        <el-table-column prop="childName" label="姓名" ></el-table-column>
        <el-table-column prop="childPetName" label="小名" ></el-table-column>
        <el-table-column prop="payConsume" label="消费金额" ></el-table-column>
        <el-table-column prop="singInTime" label="消费时间" ></el-table-column>
        <el-table-column prop="usedTimes" label="已使用卡次" ></el-table-column>
        <el-table-column prop="reduceCount" label="单次扣除卡次" ></el-table-column>
        <el-table-column prop="reduceType" label="类型" ></el-table-column>
        <el-table-column prop="produce" label="消费商品" ></el-table-column>
        <el-table-column prop="teachersInfo" label="服务泳师" ></el-table-column>
        <!--<el-table-column prop="point" label="满意度" ></el-table-column>-->
        <!--<el-table-column prop="weight" label="体重" ></el-table-column>-->
        <!--<el-table-column prop="circle" label="泳圈型号" ></el-table-column>-->
        <!--<el-table-column prop="swTime" label="游泳时常" ></el-table-column>-->
        <!--<el-table-column prop="test" label="测量" ></el-table-column>-->
        <!--<el-table-column prop="photo" label="拍照" ></el-table-column>-->
        <!--<el-table-column prop="remark" label="备注" ></el-table-column>-->
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
    <!--撤销弹窗-->
    <el-dialog
      title="撤销"
      :visible.sync="visibleDlgRevoke"
      width="50%"
      center>
      <el-form ref="registerRef"  v-model="revokeParam" label-width="140px">
        <el-form-item label="撤销原因:" >
          <el-input :autosize="{ minRows: 2, maxRows: 5}"  show-word-limit
                    maxlength="200"type="textarea" style="width: 560px" v-model="revokeParam.revokeReason" placeholder="请输入原因"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgRevoke = false">取 消</el-button>
        <el-button type="primary" @click="onRevokeConsume">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>

<script>


  import globaldata from "../../../utils/globaldata";
  import {queryCardConsume, revokeCardConsume} from "../../../api/ConsumeRecord";
  import commonUtils from "../../../utils/commonUtils";
  import {EReduceType} from "../../../utils/enumsUtil";
  import messageUtils from "../../../utils/messageUtils";

  export default {

    data() {
      return {
        listLoading: true,
        visibleDlgRevoke :false,
        queryParam:{
          userPhone: '',
          childName:"",
          childPetName:"",
          serviceTeacher:null,
          storeLessonCardId:null,
          consumeDay:"",
          startDay:"",
          endDay:"",
          lessonTemplateId:0,

          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },
        redioType:[
          {lessonTemplateId:0, des:'所有'},
          {lessonTemplateId:1, des:'亲子游'},
          {lessonTemplateId:2, des:'基础游'},
        ],


        //撤销参数
        revokeParam:{
          revokeReason:"",
        },

        multipleSelection: [],

        //表单结果
        tableData: [
        ],

        allWorker:[],

        allStoreLessonCard:[],


      }
    },
    created(){

      globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
      globaldata.getStoreLessonCard(this.getStoreLessonCard);

    },
    mounted() {

    },
    methods: {

      getStoreLessonCard(list){
        this.allStoreLessonCard =[];
        for (let i = 0; i<list.length;++i){
           if (list[i].experience == 1){
             this.allStoreLessonCard.push(list[i])
           }
        }
        let all = {
          id:null,
          name:"所有"
        }
        this.allStoreLessonCard.push(all)
      },
      getStoreWorkersInfo(list){
        this.allWorker = list;
        this.flechList();
      },

      flechList(){
        this.listLoading = true;
        let lessonTemplateId = null;
        if(this.queryParam.lessonTemplateId <=0 ){
          lessonTemplateId = null;
        }else {
          lessonTemplateId = this.queryParam.lessonTemplateId;
        }
        let param = {

          storeFrontId:globaldata.getAdminStore().storeFrontId,
          childName:this.queryParam.childName ,
          childPetName:this.queryParam.childPetName ,
          userPhone:this.queryParam.userPhone ,
          // teacherName:this.queryParam.teacherName ,
          startDay:this.queryParam.consumeDay[0],
          endDay:this.queryParam.consumeDay[1],
          serviceTeacher:this.queryParam.serviceTeacher ,
          lessonTemplateId:lessonTemplateId,
          // statu:0,
          storeLessonCardId:this.queryParam.storeLessonCardId,
          experience:1, //体验卡卡
          // cardName: this.queryParam.name,
          pageNum : this.queryParam.pageNum ,//当前第几页
          pageSize :  this.queryParam.pageSize
        }

        queryCardConsume(param).then(response =>
        {
          this.listLoading = false;
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.queryParam.totalPage = date.total;
          this.refreshData(date.list);

        })
      },
      //刷新页面数据
      refreshData(list){

        if (commonUtils.isObjectNull(list)){
          return;
        }

        let tableDataList = [];
        for (let i = 0;i< list.length;++i){
          if (commonUtils.isObjectNull(list[i].serviceTeacher) == false && list[i].serviceTeacher >0){
            let serviceTeacherName = commonUtils.getObjectBuyId(this.allWorker,list[i].serviceTeacher).name;
            list[i].serviceTeacherName = serviceTeacherName;
          }
          let reduceType = EReduceType(list[i].reduceType)
          let data = {
            id: list[i].id,
            storeFrontId: list[i].storeFrontId,
            userBuyCardId: list[i].userBuyCardId,
            childId: list[i].childId,
            userId: list[i].userId,
            cardName:list[i].cardName,
            storeLessonCardId: list[i].storeLessonCardId,
            lessonTemplateId: list[i].lessonTemplateId,
            lessonName: list[i].lessonName,
            userBookLessonId: list[i].userBookLessonId,
            userPhone: list[i].userPhone,
            singInTime:list[i].singInTime,
            childName: list[i].childName,
            childPetName: list[i].childPetName,
            payConsume: list[i].payConsume,
            time: list[i].time,
            usedTimes: list[i].usedTimes,
            reduceCount: list[i].reduceCount,
            produce: list[i].produce,
            teachersInfo:list[i].teachersInfo,
            teacher: list[i].serviceTeacherName,
            point: list[i].point,
            reduceType:reduceType,

          };
          tableDataList.push(data);
        }

        this.tableData = tableDataList;
      },
      //点击查询按钮
      onBtnSearch(){
        this.flechList();
      },

      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.flechList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
        this.flechList();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },

      /**
       * 撤销
       */
      handleRevokeConsume(){
        if (this.multipleSelection.length <=0){
          messageUtils.errorMsg(this,"请勾选需要撤销的消费记录")
          return;
        }
        this.revokeParam.revokeReason = "";
        this.visibleDlgRevoke = true;
      },

      onRevokeConsume(){
        let consumeIds = [];
        for (let i = 0;i< this.multipleSelection.length;++i){
          consumeIds.push(this.multipleSelection[i].id);
        }
        let param ={
          storeFrontId :globaldata.getAdminStore().storeFrontId,
          revokeReason:this.revokeParam.revokeReason,
          consumeIds:consumeIds,
        }

        revokeCardConsume(param).then(response =>
        {

          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          if (data == true){
            messageUtils.successMsg(this,response.message)
          } else {
            messageUtils.errorMsg(this,response.message)
          }
          this.visibleDlgRevoke = false;

          this.flechList();

        })

      }
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/consume/experience-card-consume/index.vue